import { PublicKey, TransactionInstruction } from "@solana/web3.js";
import BN from "bn.js";
import { ConfigFields, ReferralProgram } from "../type";

export interface IUpdateConfigParams {
  referralProgram: ReferralProgram;
  stakingAddress: PublicKey;
  owner: PublicKey;
  fieldsToUpdate: ConfigFields[];
}

export async function createUpdateConfigIx(
  params: IUpdateConfigParams,
): Promise<TransactionInstruction> {
  const { referralProgram, stakingAddress, owner, fieldsToUpdate } = params;

  return referralProgram.methods
    .updateConfig({
      fieldsToUpdate,
      padding0: Array(8).fill(new BN(0)),
    })
    .accountsPartial({
      staking: stakingAddress,
      owner,
    })
    .instruction();
}
